import { currencies, Currency } from '../../constants/currency';

export const getFormattedPrice = (
  totalPrice: number | undefined,
  currencySymbol: string,
  appendStar?: boolean,
  hideCurrency?: boolean
): string => {
  const currency = currencies.find(
    (curr: Currency) => curr.symbol === currencySymbol
  );
  const isNegative = (totalPrice ?? 0) < 0;

  const totalPriceString = Math.abs(totalPrice ?? 0).toFixed(2);

  let result = '';

  if (!hideCurrency) {
    if (currency && currency.prefixPlace) {
      result = `${currencySymbol}${totalPriceString}`;
    } else {
      result = `${totalPriceString}${currencySymbol}`;
    }
  }

  if (appendStar) {
    result += '*';
  }

  if (isNegative) {
    result = `-${result}`;
  }

  return result;
};
